<section class="not-found-container">
  <h2 class="heading">Page not found.</h2>
  <div>We're sorry. The page you are looking for cannot be found.</div>
</section>
